import { render } from "./MyCashView.vue?vue&type=template&id=b5edb7a4&scoped=true"
import script from "./MyCashView.vue?vue&type=script&lang=js"
export * from "./MyCashView.vue?vue&type=script&lang=js"

import "./MyCashView.vue?vue&type=style&index=0&id=b5edb7a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5edb7a4"]])

export default __exports__